/**
 * Employee Document Events - Betrieb Müller (v2)
 *
 * Events related to employee certifications and safety briefings.
 */

import type { MockControlEvent } from '@hofsync/design-system';
import { hoursAgo, monthsFromNow } from '../farm-profile';
import { PFLSCHSACHKV_7 } from '../../legal';
import { EMPLOYEE_KLAUS, EMPLOYEE_THOMAS } from '../entities/employees';

/**
 * Event 6 (THIS SEASON - Shown): Sachkunde Aggregate (WARNING)
 */
export const EVENT_SACHKUNDE_AGGREGATE: MockControlEvent = {
  id: 'evt-sachkunde-aggregate',
  type: 'obligation-due',
  priority: 'warning',
  title: 'Sachkunde: 1 Fortbildung in 4 Monaten fällig',
  subtitle: 'Pflanzenschutz-Sachkunde',
  timestamp: hoursAgo(12),
  relevantDate: monthsFromNow(4), // May 2026
  relatedEntity: { name: 'Mitarbeiter', href: '#employees' },
  categories: ['sachkunde', 'fristen'],
  controlType: 'Sachkundenachweis',
  controlReadiness: {
    status: 'warning',
    metCount: 1,
    totalCount: 2,
    label: '1 von 2 aktuell',
  },
  reasoning: {
    summary: 'Sachkundenachweis Pflanzenschutz muss alle 3 Jahre durch Fortbildung erneuert werden.',
    legalBasis: [PFLSCHSACHKV_7],
    actionRecommendation:
      'Fortbildung bei der Landwirtschaftskammer oder anerkannten Anbietern buchen (z.B. DEULA, LWK). ' +
      'Kurse dauern 4 Stunden und können oft online absolviert werden.',
    factors: [
      { label: 'Mitarbeiter mit Sachkunde', value: '2' },
      { label: 'Davon aktuell', value: '1' },
      { label: 'Nächste Fortbildung', value: 'Mai 2026' },
      { label: 'Fortbildungszyklus', value: '3 Jahre' },
    ],
    confidence: 'high',
  },
  entities: [EMPLOYEE_KLAUS, EMPLOYEE_THOMAS],
  // Aggregate event properties
  isAggregate: true,
  hideAggregateBadge: true,
  affectedEntities: [
    {
      id: 'person-klaus',
      name: 'Klaus Müller (Betriebsinhaber)',
      type: 'person',
      severity: 'warning',
      status: 'Fortbildung fällig bis Mai 2026',
      dueDate: new Date('2026-05-31'),
      action: { label: 'Fortbildung buchen', href: '/my-farm/employees/klaus' },
    },
    {
      id: 'person-thomas',
      name: 'Thomas Weber',
      type: 'person',
      severity: 'info',
      status: 'Gültig bis September 2026',
      action: { label: 'Nachweis anzeigen', href: '/my-farm/employees/thomas' },
    },
  ],
  domainLink: {
    label: 'Alle Mitarbeiter anzeigen',
    href: '/my-farm/employees',
  },
};

/**
 * All employee document events
 */
export const EMPLOYEE_DOC_EVENTS: MockControlEvent[] = [EVENT_SACHKUNDE_AGGREGATE];
